export enum SiteFilterActionType {
  // Load
  LoadSiteFilter = 'LOAD_SITE_FILTER',
  LoadSiteFilterCompleted = 'LOAD_SITE_FILTER_COMPLETED',
  LoadSiteFilterFailed = 'LOAD_SITE_FILTER_FAILED',
  // Update
  UpdateSiteFilter = 'UPDATE_SITE_FILTER',
  UpdateSiteFilterCompleted = 'UPDATE_SITE_FILTER_COMPLETED',
  UpdateSiteFilterFailed = 'UPDATE_SITE_FILTER_FAILED',
  // Load for management
  LoadManagmentSiteFilter = 'LOAD_MANAGEMENT_SITE_FILTER',
  LoadManagmentSiteFilterCompleted = 'LOAD_MANAGEMENT_SITE_FILTER_COMPLETED',
  LoadManagmentSiteFilterFailed = 'LOAD_MANAGEMENT_SITE_FILTER_FAILED',
  // Update
  UpdateManagmentSiteFilterCategory = 'UPDATE_MANAGEMENT_SITE_FILTER_CATEGORY',
  UpdateManagmentSiteFilterCategoryCompleted = 'UPDATE_MANAGEMENT_SITE_FILTER_CATEGORY_COMPLETED',
  UpdateManagmentSiteFilterCategoryFailed = 'UPDATE_MANAGEMENT_SITE_FILTER_CATEGORY_FAILED',

  UpdateManagementSiteFilterItem = 'UPDATE_MANAGEMENT_SITE_FILTER_ITEM',
  UpdateManagementSiteFilterItemCompleted = 'UPDATE_MANAGEMENT_SITE_FILTER_ITEM_COMPLETED',
  UpdateManagementSiteFilterItemFailed = 'UPDATE_MANAGEMENT_SITE_FILTER_ITEM_FAILED',
  // Create
  CreateManagementSiteFilterItem = 'CREATE_MANANGEMENT_SITE_FILTER_ITEM',
  CreateManagementSiteFilterItemCompleted = 'CREATE_MANANGEMENT_SITE_FILTER_ITEM_COMPLETED',
  CreateManagementSiteFilterItemFailed = 'CREATE_MANANGEMENT_SITE_FILTER_ITEM_FAILED',
  // Delete
  DeleteManagementSiteFilterItem = 'DELETE_MANAGEMENT_SITE_FILTER_ITEM',
  DeleteManagementSiteFilterItemCompleted = 'DELETE_MANAGEMENT_SITE_FILTER_ITEM_COMPLETED',
  DeleteManagementSiteFilterItemFailed = 'DELETE_MANAGEMENT_SITE_FILTER_ITEM_FAILED',
}
